export default class Card {
  static init() {
    const section = document.querySelector('[data-module="card"]');

    if (!section) {
      return;
    }

    const card = section.querySelector('.card');

    if (card) {
      card.classList.add('is-ready');
    }
  }
}
